export class AppPermissionConsts {
  static readonly GroupName = 'SmartInvoicing';

  static readonly MasterPermission = this.GroupName + '.Master';
  static readonly ExternalPermission = this.GroupName + '.External';

  static readonly PlaceDefault = this.GroupName + '.Place';
  static readonly PlaceCreate = this.PlaceDefault + '.Create';
  static readonly PlaceEdit = this.PlaceDefault + '.Edit';
  static readonly PlaceDelete = this.PlaceDefault + '.Delete';

  static readonly RoleVendorDefault = this.GroupName + '.RoleVendor';
  static readonly RoleVendorEdit = this.RoleVendorDefault + '.Edit';

  static readonly ExternalSystemDefault = this.GroupName + '.ExternalSystem';
  static readonly ExternalSystemCreate = this.ExternalSystemDefault + '.Create';
  static readonly ExternalSystemEdit = this.ExternalSystemDefault + '.Edit';
  static readonly ExternalSystemDelete = this.ExternalSystemDefault + '.Delete';

  static readonly VendorDefault = this.GroupName + '.Vendor';
  static readonly VendorCreate = this.VendorDefault + '.Create';
  static readonly VendorEdit = this.VendorDefault + '.Edit';
  static readonly VendorDelete = this.VendorDefault + '.Delete';

  static readonly ServiceDefault = this.GroupName + '.Service';
  static readonly ServiceCreate = this.ServiceDefault + '.Create';
  static readonly ServiceEdit = this.ServiceDefault + '.Edit';
  static readonly ServiceDelete = this.ServiceDefault + '.Delete';

  static readonly ProviderDefault = this.GroupName + '.Provider';
  static readonly ProviderCreate = this.ProviderDefault + '.Create';
  static readonly ProviderEdit = this.ProviderDefault + '.Edit';
  static readonly ProviderDelete = this.ProviderDefault + '.Delete';

  static readonly UserProviderDefault = this.GroupName + '.UserProvider';
  static readonly UserProviderAssign = this.UserProviderDefault + '.Assign';

  static readonly ServiceConfigurationDefault = this.GroupName + '.ServiceConfiguration';
  static readonly ServiceConfigurationCreate = this.ServiceConfigurationDefault + '.Create';
  static readonly ServiceConfigurationEdit = this.ServiceConfigurationDefault + '.Edit';
  static readonly ServiceConfigurationDelete = this.ServiceConfigurationDefault + '.Delete';

  static readonly ActionDefault = this.GroupName + '.Action';
  static readonly ActionEdit = this.ActionDefault + '.Edit';
  static readonly ActionDelete = this.ActionDefault + '.Delete';

  static readonly PeriodDefault = this.GroupName + '.Period';
  static readonly PeriodCreate = this.PeriodDefault + '.Create';
  static readonly PeriodEdit = this.PeriodDefault + '.Edit';
  static readonly PeriodDelete = this.PeriodDefault + '.Delete';

  static readonly ServiceEntrySheetGenerationDefault = this.GroupName + '.ServiceEntrySheetGeneration';
  static readonly ServiceEntrySheetGenerationViewPendingOrderLines = this.ServiceEntrySheetGenerationDefault + '.ViewPendingOrderLines';
  static readonly ServiceEntrySheetGenerationRevert = this.ServiceEntrySheetGenerationDefault + '.Revert';
  
  static readonly ServiceEntrySheetsDefault = this.GroupName + '.ServiceEntrySheetVisualization'
  static readonly ServiceEntrySheetsLogs = this.ServiceEntrySheetsDefault + '.Logs'
  static readonly ServiceEntrySheetsReport = this.ServiceEntrySheetsDefault + '.Report'
  static readonly ServiceEntrySheetsIntegrations = this.ServiceEntrySheetsDefault + '.Integrations'
  static readonly ServiceEntrySheetsIntegrationLogs = this.ServiceEntrySheetsDefault + '.IntegrationLogs';
  
  static readonly ExternalDefault = this.GroupName + '.External';
  static readonly CreateOrderLine = this.ExternalDefault + '.CreateOrderLine';
  static readonly ServiceEntrySheetGeneration = this.ServiceEntrySheetGenerationDefault + '.Generate';
  static readonly ServiceEntrySheetGenerationForAllLines = this.ServiceEntrySheetGenerationDefault + '.GenerateForAllLines';

  static readonly IsProvider = this.GroupName + '.IsProvider';

  static readonly IntegrationMonitorDefault = this.GroupName + '.IntegrationMonitor';
  static readonly ExecuteIntegrationManually = this.IntegrationMonitorDefault + '.ExecuteManually';

  static readonly ProviderConfigurationDefault = this.GroupName + '.ProviderConfiguration';
  static readonly ProviderConfigurationCreate = this.ProviderConfigurationDefault + '.Create';
  static readonly ProviderConfigurationEdit = this.ProviderConfigurationDefault + '.Edit';
  static readonly ProviderConfigurationDelete = this.ProviderConfigurationDefault + '.Delete';
  
  static readonly ServiceTypeDefault = this.GroupName + '.ServiceType';
  static readonly ServiceTypeCreate = this.ServiceTypeDefault + '.Create';
  static readonly ServiceTypeEdit = this.ServiceTypeDefault + '.Edit';
  static readonly ServiceTypeDelete = this.ServiceTypeDefault + '.Delete';
}
